import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCorsairComponent } from './simple-icons-corsair.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCorsairComponent ],
    exports:      [ SimpleIconsCorsairComponent ],
    bootstrap:    []
})
export class SimpleIconsCorsairModule {}
